export default __webpack_public_path__ + "static/mainimge-coin-110ccf4d20ecf8147bb14c4a99a702ce.png";